import React from 'react';

import { TableCell, TableRow } from '@mui/material';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import styles from './tableHeaderInfo.module.css';

const TableHeaderInfo = (props) => {
    const { totalCount, rows } = props;

    const loadedListingsCount = rows.length;
    const isAllListingsLoaded = loadedListingsCount === totalCount;

    const getDescription = () => {
        if (isAllListingsLoaded)
            return (
                <>
                    All <b>{totalCount}</b> listings are shown
                </>
            );

        return (
            <>
                <b className={styles.totalCountTextBold}>{loadedListingsCount}</b> of{' '}
                <b className={styles.totalCountTextBold}>{totalCount}</b> listings are shown
            </>
        );
    };

    return (
        <TableRow>
            <TableCell
                colSpan={4}
                className={clsx(styles.optionCell, styles.totalCountText)}
                align="right"
            >
                {getDescription()}
            </TableCell>
        </TableRow>
    );
};

TableHeaderInfo.propTypes = {
    totalCount: PropTypes.number,
    rows: PropTypes.array,
};

export default TableHeaderInfo;
